<script>
import { Query } from "@sveltestack/svelte-query"
import { startOfWeek, endOfWeek, format } from "date-fns"
import API from "@local/utils/api"
import List from "@local/components/List.svelte"
import EmptyMessage from "@local/components/EmptyMessage.svelte"
import TextInput from "@local/components/form/TextInput.svelte"
import Select from "@local/components/form/Select.svelte"
import Icon from "@local/components/images/Icon.svelte"
import { onMount } from "svelte" // Importe onMount
import * as XLSX from "xlsx"
import BackToTop from "@local/components/BackToTop.svelte"

let doctorOptions = ["Blake Pearson"]
let periodOptions = [
  {
    label: "Jul 2026 - Dec 2026",
    from: "2026/07/01",
    to: "2026/12/31",
  },
  {
    label: "Jan 2026 - Jun 2026",
    from: "2026/01/01",
    to: "2026/06/30",
  },
  {
    label: "Jul 2025 - Dec 2025",
    from: "2025/07/01",
    to: "2025/12/31",
  },
  {
    label: "Jan 2025 - Jun 2025",
    from: "2025/01/01",
    to: "2025/06/30",
  },
  {
    label: "Jul 2024 - Dec 2024",
    from: "2024/07/01",
    to: "2024/12/31",
  },
  {
    label: "Jan 2024 - Jun 2024",
    from: "2024/01/01",
    to: "2024/06/30",
  },
  {
    label: "Jul 2023 - Dec 2023",
    from: "2023/07/01",
    to: "2023/12/31",
  },
  {
    label: "Jan 2023 - Jun 2023",
    from: "2023/01/01",
    to: "2023/06/30",
  },
  {
    label: "Jul 2022 - Dec 2022",
    from: "2022/07/01",
    to: "2022/12/31",
  },
  {
    label: "Jan 2022 - Jun 2022",
    from: "2022/01/01",
    to: "2022/06/30",
  },
  {
    label: "Jul 2021 - Dec 2021",
    from: "2021/07/01",
    to: "2021/12/31",
  },
  {
    label: "Jan 2021 - Jun 2021",
    from: "2021/01/01",
    to: "2021/06/30",
  },
]

let queryVal = doctorOptions[0] || ""
let periodVal = periodOptions[0]
let filters = {
  query: queryVal,
  scheduledToDateFrom: periodVal.from,
  scheduledToDateTo: periodVal.to,
}

function search() {
  console.log({ queryVal, periodVal })

  const newFilters = {
    query: queryVal,
    scheduledToDateFrom: periodVal.from,
    scheduledToDateTo: periodVal.to,
  }
  filters = newFilters
}

async function fetchWorkflows(filters) {
  const defKey = "admPhipaReport"
  const searchParams = {
    role: "admin",
    page: 0,
    perPage: 10000000,
    timeout: false,
    ...filters,
  }

  console.log({ searchParams })
  const response = await API.get(`lists/def-key/${defKey}`, {
    searchParams,
  })
  const rows = await response.json()

  return { rows }
}

function buildFileName(queryVal) {
  const doctorFirstName = queryVal?.split(" ")?.[0]?.toLowerCase() || ""
  return doctorFirstName + "-" + periodVal.label
}

function downloadXLSX(rows, queryVal) {
  if (!rows || rows.length === 0) return
  console.log({ x: rows.length })
  const header = rows[0].columns.map((row) => row.label)
  const data = rows.map((row) => row.columns.map((col) => col.value))
  const worksheet = XLSX.utils.aoa_to_sheet([header, ...data])
  const workbook = XLSX.utils.book_new()
  console.log(XLSX.utils.sheet_to_json(worksheet).length)
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report")
  const fileName = buildFileName(queryVal) + ".xlsx"
  XLSX.writeFile(workbook, fileName)
  console.log(worksheet["!ref"])
}

$: queryOptions = {
  queryKey: ["reports/phipa", JSON.stringify(filters)],
  queryFn: () => fetchWorkflows(filters),
  keepPreviousData: true,
  refetchOnWindowFocus: false,
}
</script>

<Query options="{queryOptions}">
  <div class="p-5" slot="query" let:queryResult>
    {#if queryResult.isLoading}
      <div></div>
    {:else if queryResult.error}
      <EmptyMessage icon="error">{queryResult.error}</EmptyMessage>
    {:else}
      <div class="flex flex-row items-center justify-between mb-6">
        <h2 class="h2">Report: PHIPA</h2>
      </div>
      <div class="flex items-end gap-2 mb-2">
        <form
          class="flex items-end w-full gap-2"
          on:submit|preventDefault="{search}"
        >
          <Select
            bind:value="{queryVal}"
            options="{doctorOptions}"
            label="Doctors"
            placeholder="Doctors"
          />
          <Select
            bind:value="{periodVal}"
            options="{periodOptions}"
            label="Period"
            placeholder="Period"
          />
          <button
            class="flex items-center justify-center flex-shrink-0 w-10 h-10 btn btn-outline disabled:opacity-50"
            type="submit"
            disabled="{queryResult.isFetching}"
          >
            {#if queryResult.isFetching}
              <Icon size="3xl">progress_activity</Icon>
            {:else}
              <Icon size="3xl">search</Icon>
            {/if}
          </button>

          {#if queryResult.data.rows.length > 0}
            <button
              class="flex items-center justify-center flex-shrink-0 w-10 h-10 btn btn-outline"
              type="button"
              on:click="{() => downloadXLSX(queryResult.data.rows, queryVal)}"
              title="Download XLSX"
            >
              <Icon size="3xl">download</Icon>
            </button>
          {/if}
        </form>
      </div>
      {#if queryResult.isFetching}
        <div class="flex flex-col items-center justify-center py-10">
          <Icon
            size="5xl"
            class="animate-spin text-gray-800 dark:text-gray-200"
          >
            progress_activity
          </Icon>
        </div>
      {:else if queryResult.data.rows.length > 0}
        <List rows="{queryResult.data.rows}" />
      {:else}
        <EmptyMessage icon="check">No records</EmptyMessage>
      {/if}
    {/if}
  </div>
</Query>

<BackToTop />
